import { ConversationSchemaDbParser } from "@redotech/redo-model/conversation/conversation-schema-db-parser";
import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { coerce } from "zod";
const sortOrderValues = ["asc", "desc"] as const;
const sortOrderEnum = createEnum(sortOrderValues);
// type SortOrder = z.infer<typeof sortOrderEnum>;
//
// type ZodCoercedDate = ReturnType<typeof coerce.date>;

export const CONVERSATION_FILTER_TYPES = [
  "all",
  "replied",
  "awaiting",
  "escalated",
] as const;
export const conversationFilterTypeEnum = createEnum(CONVERSATION_FILTER_TYPES);
export type ConversationFilterType = z.infer<typeof conversationFilterTypeEnum>;

const inputSchema = z
  .object({
    teamId: z.string(),
    startDate: coerce.date().optional(),
    endDate: coerce.date().optional(),
    categories: z.array(z.string()).optional(),
    paginationToken: z
      .object({ lastResponseAt: coerce.date(), _id: zExt.objectId() })
      .optional(),
    sortOrder: sortOrderEnum.default("desc"),
    limit: z.number().min(1).max(100).default(10),
    textConciergeOnly: z.boolean().optional(),
    filterType: conversationFilterTypeEnum.optional(),
    search: z.string().trim().max(200).optional(),
  })
  .strict();
export const GetConversationsInputSchema: z.ZodType<GetConversationsInput> =
  inputSchema;
export interface GetConversationsInput extends z.infer<typeof inputSchema> {}

const outputSchema = z.object({
  conversations: z.array(ConversationSchemaDbParser),
  nextPaginationToken: z
    .object({ lastResponseAt: coerce.date(), _id: zExt.objectId() })
    .nullable(),
});

export const GetConversationsOutputSchema: z.ZodType<GetConversationsOutput> =
  outputSchema;
export interface GetConversationsOutput extends z.infer<typeof outputSchema> {}

export const getConversations = unaryRpc({
  name: "getConversations",
  input: GetConversationsInputSchema,
  output: GetConversationsOutputSchema,
});
